<div class="modal-overlay" (click)="onClose()">
  <div class="modal-container" (click)="$event.stopImmediatePropagation()">
    <button class="close-btn" (click)="onClose()">×</button>

    <!-- Modal Header -->
    <div class="modal-header">
      <div class="mac_content">
        {{ macAddressClicked }}
      </div>
    </div>

    <!-- Table Wrapper -->
    <div class="container-max table-responsive">
      <table class="device-table fade-in">
        <!-- Table Head always visible -->
        <thead>
          <tr>
            <th>#</th>
            <th>MAC Address</th>
            <th>Online Time</th>
            <th>Offline Time</th>
            <th>Summary Files</th>
            <th>Max Offline Duration</th>
            <th>Max Offline Start</th>
            <th>Max Offline End</th>
            <th>Total Monitored</th>
            <th>Online %</th>
            <th>Offline %</th>
          </tr>
        </thead>

        <!-- Table Body: loader OR data -->
        <tbody>
          @if (isLoading) {
            <tr>
              <td colspan="11">
                <div class="loading-container">
                  <div class="loading-spinner"></div>
                  <p class="loading-text">Just a moment — loading your device insights...</p>
                </div>
              </td>
            </tr>
          } @else {
            @for (item of listData; let i = $index; track $index) {
              <tr>
                <td>{{ i + 1 }}</td>
                <td><b>{{ item.mac_address }}</b></td>
                <td>{{ secondsToDDHHMMSS(item.total_online_time) }}</td>
                <td>{{ secondsToDDHHMMSS(item.total_offline_time) }}</td>
                <td>{{ item.number_of_summary_files }}</td>
                <td>{{ secondsToDDHHMMSS(item.longest_offline_duration) }}</td>
                <td>{{ item.longest_offline_start || 'N/A' }}</td>
                <td>{{ item.longest_offline_end || 'N/A' }}</td>
                <td>{{ secondsToDDHHMMSS(item.total_seconds) }}</td>
                <td><span class="status-indicator status-excellent"></span>{{ item.online_percentage }}%</td>
                <td><span class="status-indicator status-attention"></span>{{ item.offline_percentage }}%</td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
  </div>
</div>
